import type { SelectOption } from '../../components';
import type {
  DurationMonthsFilter,
  InvoiceFilterQueryParams,
  InvoiceFilters,
  PlanStatusFilter,
  TimePeriodFilter,
} from '../../types/userInvoice';

export const DEFAULT_INVOICE_FILTERS: InvoiceFilters = {
  status: 'all',
  timePeriod: 'all_time',
  durationMonths: 0,
};

export const PLAN_STATUS_FILTERS: { label: string; value: PlanStatusFilter }[] = [
  { label: 'Active', value: 'active' },
  { label: 'Expired', value: 'expired' },
  { label: 'All Plans', value: 'all' },
];

export const TIME_PERIOD_OPTIONS: SelectOption[] = [
  { value: 'last_7_days', label: 'Last 7 Days' },
  { value: 'last_30_days', label: 'Last 30 Days' },
  { value: 'last_90_days', label: 'Last 90 Days' },
  { value: 'all_time', label: 'All Time' },
];

export const DURATION_MONTHS_OPTIONS: SelectOption[] = [
  { value: '0', label: 'All Durations' },
  { value: '1', label: '1 Month' },
  { value: '3', label: '3 Months' },
  { value: '6', label: '6 Months' },
  { value: '12', label: '12 Months' },
];

const VALID_DURATION_MONTHS: DurationMonthsFilter[] = [0, 1, 3, 6, 12];

export const parsePlanStatusFilter = (value: string | null): PlanStatusFilter => {
  if (value === 'active' || value === 'expired') return value;
  return 'all';
};

export const toDurationMonthsFilter = (value: string): DurationMonthsFilter => {
  const parsed = Number(value);
  if (VALID_DURATION_MONTHS.includes(parsed as DurationMonthsFilter)) {
    return parsed as DurationMonthsFilter;
  }
  return 0;
};

/** Map UI filter state to API query params (omits "all" sentinel values). */
export const buildInvoiceFilterQuery = (filters: InvoiceFilters): InvoiceFilterQueryParams => {
  const query: InvoiceFilterQueryParams = {};

  if (filters.status !== 'all') {
    query.status = filters.status;
  }

  if (filters.timePeriod !== 'all_time') {
    query.timePeriod = filters.timePeriod;
  }

  if (filters.durationMonths !== 0) {
    query.durationMonths = filters.durationMonths;
  }

  return query;
};

export const hasActiveInvoiceFilters = (filters: InvoiceFilters): boolean =>
  filters.status !== DEFAULT_INVOICE_FILTERS.status
  || filters.timePeriod !== DEFAULT_INVOICE_FILTERS.timePeriod
  || filters.durationMonths !== DEFAULT_INVOICE_FILTERS.durationMonths;
